import { commissionPercentStringFromRate, rateFromPercentInput } from "@/lib/commissionRate";
import type { House, HouseAdminUpdate, HouseUpdate } from "@/types";

export type HouseHostDetailFormValues = {
  name: string;
  address: string;
  coordinates: { lat: number; lng: number } | null;
};

export type HouseAdminDetailFormValues = HouseHostDetailFormValues & {
  commission_percent: string;
  is_active: boolean;
};

export function buildHouseHostFormDefaults(
  house: House,
): HouseHostDetailFormValues {
  return {
    name: house.name,
    address: house.address || "",
    coordinates: house.coordinates ?? null,
  };
}

export function buildHouseAdminFormDefaults(
  house: House,
): HouseAdminDetailFormValues {
  return {
    ...buildHouseHostFormDefaults(house),
    commission_percent: commissionPercentStringFromRate(house.commission_rate),
    is_active: house.is_active,
  };
}

export function houseUpdateFromHostForm(
  values: HouseHostDetailFormValues,
): HouseUpdate {
  const address = values.address.trim();
  return {
    name: values.name.trim(),
    address: address || undefined,
    coordinates: values.coordinates,
  };
}

export function houseUpdateFromAdminForm(
  values: HouseAdminDetailFormValues,
): HouseAdminUpdate {
  const update = houseUpdateFromHostForm(values) as HouseAdminUpdate;
  update.is_active = values.is_active;

  const rate = rateFromPercentInput(values.commission_percent);
  if (rate !== null) {
    update.commission_rate = rate;
  }

  return update;
}
